import EventManager from "../../store/sqftEventManager";
import workspace from "../workspace";
import config from "../../store/sqftConfig";
import store from "./../../../../../../store";
import {
  deleteChangeValuePopup, setFeaturePicker,
  setSQFTActiveButton, setSQFTActiveLevel3Button, setSQFTActiveShapeId, setSQFTActiveSubMenuButton, setSQFTContextMenu,
  setSQFTMenuOpened,
  setSQFTMenuOpenedLock, setSQFTSystemDeleteMessage
} from "../../../../../../actions/sqftMenuFunctions";
import {
  SIDEBAR_SHAPE_BUTTONS,
  SIDEBAR_NAVIGATION_BUTTONS,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS,
  SIDEBAR_SLAB_BUTTONS,
  SHAPE_PART_ID,
  FREE_FORM_THICKNESS_POPUP_ID,
  SIDEBAR_TYPE_AREA_NAVIGATION_BUTTONS, SIDEBAR_HIDDEN_BUTTONS,
} from "../../../../constants";
import {getMousePositionOnField} from "../../../../helpers/sqftHelper";
import TextBox from "./textBox";
import sqftEventManager from "../../store/sqftEventManager";
import sqftConfig from "../../store/sqftConfig";
import {clearRotateAngles} from "../../store/canvasHelper";
import {updateSQFTCalculations} from "../../../../../../actions/sqftFunctions";
import FreeDraw from "../controls/freeDraw";
import Duplicate from "../controls/duplicate";
import sqftShape from "../shapes/sqftShape";
import MovableImage from "../shapes/movableImage";
import sqftShapeManager from "../../store/sqftShapeManager";
import workspaceControllers from "../../store/workspaceControllers";
import MiteredController from "../controls/mitered";
import {showFilters} from "../../../../../../actions/actionFunctions";
import {setGroheFiltersSearchText} from "../../../../../../actions/groheFunctions";
import toolsControllers from "../../store/toolsControllers";
import {closeSQFTPopup} from "../controls/resourseCanas";

const WorkspaceEvents = function() {
  let self = this;
  this.workspace_onClick = (mousePos) => {
    let tookAction = false;
    const state = store.getState();
    const activeButton = state.sqftMenuState.activeButton;
    const isShowSlabTool = state.sqftSlabState.isShowSlabTool;
    const isWallsLockMode = state.sqftMenuState.isWallsLockMode;
    const isITextEditing = state.sqftMenuState.isITextEditing;
    //const shapes = workspace.getShapes();
    const shape = workspace.getHoverShape();
    const bumpoutLine = workspace.getHoverBumpout();
    const textBoxes = workspace.textBoxManager.getTextBoxes();
    let cursor = EventManager.getCursor();

    if ([SIDEBAR_SHAPE_BUTTONS.freeDraw,
        SIDEBAR_TYPE_AREA_NAVIGATION_BUTTONS.freeDraw].includes(activeButton)
      && !workspace.getHoverPoint()
    ) {
      FreeDraw.initDraw(isWallsLockMode);
      FreeDraw.drawCountertopShape(mousePos);
      return false;
    } else if ([SIDEBAR_HIDDEN_BUTTONS.buttonBacksplashFreeDraw].includes(activeButton)
      && !workspace.getHoverPoint()
    ) {
      FreeDraw.initDraw(isWallsLockMode);
      FreeDraw.drawBacksplashShape(mousePos);
      return false;
    } else if (activeButton === SIDEBAR_SHAPE_BUTTONS.shapeFreeForm
      && !workspace.getHoverPoint()
    ) {
      toolsControllers.shapeFreeForm.initDraw(isWallsLockMode);
      toolsControllers.shapeFreeForm.drawShape(mousePos);
      return false;
    }

    if (workspaceControllers.spacer.isJustCreated) {
      workspaceControllers.spacer.setIsJustCreated(false);
      return false;
    }

    if (shape || workspace.getLineWithMovingBumpout()) {
      const sideOpened = state.sqftMenuState.menuOpened;

      if (!sideOpened
        && !isShowSlabTool
        && activeButton !== "move"
        && activeButton !== "label"
        && activeButton !== "rotate"
        && activeButton !== "angle"
        && activeButton !== "freeDraw"
        && activeButton !== "resize"
        && activeButton !== "waterfall"
        && cursor && (cursor[0] === "move" || cursor[0] === "grab")
      ) {
        store.dispatch(setSQFTMenuOpened("move"));
        store.dispatch(setSQFTActiveButton("move"));
        resetEvents();
        config.workspace.menuItemActive = "move";
        //this.sideBarButtonClick(nodes.sidebar.mainNavButton, !config.highlight.rotateAngle);
      }
      store.dispatch(setSQFTMenuOpenedLock(true));
    } else {
      //1) close opened menus
      // todo sqft-react
      // this.hideSidebarSide();
      // this.hideSideBarContent();
      this.hideAngleTooltip();
      //2) remove active class from main button

      // todo sqft-react
      //this.removeActiveClassFromMainButton()
      //nodes.sidebar.mainNavButton.classList.remove(classes.buttonActiveClass);
    }

    if (activeButton) { //if (config.workspace.menuItemActive) {
      //tookAction = true;
      let resetCursor = false;
      if (shape) {
        let line;
        switch(activeButton) { // switch(config.workspace.menuItemActive) {
          case "delete":
            //todo priority
            if (textBoxes.length > 0) {
              for (let textBox of textBoxes) {
                if (textBox.box.mixin.movable.state.hovering) {
                  //box.delete();
                  return;
                }
              }
            }
            if (shape.type === "appliances") {
              workspace.removeShape(shape);
            } else if (shape.type === "slabImage" || shape.partId === SHAPE_PART_ID.slabPlaceHolder) {
              workspace.updateRemovedFeatures(shape);
              workspace.removeSlabImage(shape);
            } else {
              const line = shape.getHoverSegment() || shape.getHoverSegmentOutlineCorner();
              const point = shape.getHoverPointOnClick(mousePos);
              const cornerLine = shape.getHoverSegmentCorner();
              const miteredPoint = shape.getHoverMiteredPoint();
              const label = shape.getHoverLabel();

              if (cornerLine) {
                if (cornerLine.getAttachedItems()) {
                  cornerLine.deleteAttachedItem();
                } else {
                  cornerLine.line.to.removeAttachedItem();
                }
              } else if (point && (point.getArcLength() || point.getAngle() || point.getMiteredFeatureId())) {
                point.removeAttachedItem();
                tookAction = false;
              } else if (miteredPoint && line) {
                line.miteredOverlay.deletePoint(miteredPoint);
                line.miteredOverlay.resetHoveredPoint();
              } else if (line && line.getAttachedItems()) {
                //workspace.removeShape(line.getAttachedShape());
                line.deleteAttachedItem();
              } else if (label) {
                const lineWithTheLabel = label.getParent();
                lineWithTheLabel.labelOverlay.destroy();
                lineWithTheLabel.labelOverlay = null;
              } else if (!isShowSlabTool) {
                // shapeToDelete = shape;
                // self.callConfirmPopup(mousePos);
                store.dispatch(setSQFTSystemDeleteMessage({isOpened: true, shape: shape}));
                tookAction = false;
              } else {
                tookAction = false;
              }
            }
            //config.controls.delete.removeClass(config.activeClass);
            //nodes.designPatterns.delete.removeClass(config.activeClass);
            break;
          case "flip-h":
            shape.flip(shape.FlipDirection.HORIZONTAL);
            config.controls.flipH.removeClass(config.activeClass);
            resetCursor = true;
            break;
          case "flip-v":
            shape.flip(shape.FlipDirection.VERTICAL);
            config.controls.flipV.removeClass(config.activeClass);
            resetCursor = true;
            break;
          case "rotate-right":
            // rotate v1 disabled
            // shape.rotate(90, shape.Direction.RIGHT);
            //config.controls.rotateRight.removeClass(config.activeClass);
            //nodes.designPatterns.rotateRight.removeClass(config.activeClass);
            break;
          case "rotate-left":
            // activated from activeButton
            //shape.rotate(90, shape.Direction.LEFT);

            //config.controls.rotateLeft.removeClass(config.activeClass);
            //nodes.designPatterns.rotateLeft.removeClass(config.activeClass);
            break;
          case SIDEBAR_NAVIGATION_BUTTONS.label:
            EventManager.stealCursor(true);
            EventManager.resetCursor(self);

            if (store.getState().sqftMenuState.contextMenu.isOpened) {
              store.dispatch(setSQFTContextMenu({isOpened: false}));
            }
            store.dispatch(setSQFTContextMenu({isOpened: true, activeMenu: "labels", pos: mousePos, parent: shape}));
            tookAction = false;

            break;
          default:
            tookAction = false;
            break;
        }
        switch(activeButton) {
          case SIDEBAR_SLAB_BUTTONS.rotate:
            //rotate in slab and regular mode
            //rotate v2
            //shape.rotate(90, shape.Direction.LEFT, isShowSlabTool);
            //todo shape rotation with bumpout disabled
            if (sqftShapeManager.wasShapesDragging()) {
             // user just finished dragging the shape in rotate mode – do not rotate
             tookAction = false;
             break;
            }
            if (sqftShapeManager.canShapeBeRotated(shape)) {
              if (!shape.getIsRotatable()) {
                sqftShapeManager.closeRotatablePopups(shape);
                sqftShapeManager.setShapeAsRotatable(shape);
              }
              sqftShapeManager.rotateShapeTo90Deg(shape);
            }
            tookAction = false;
            break;
          case SIDEBAR_NAVIGATION_BUTTONS.duplicate:
            if (shape instanceof sqftShape && !isShowSlabTool
              || shape instanceof sqftShape && shape.partId === SHAPE_PART_ID.slabPlaceHolder
            ) {
              Duplicate.cloneShape(shape);
            } else if (shape instanceof MovableImage) {
              Duplicate.cloneMovableImage(shape);
            }

            tookAction = false;

            break;
          case SIDEBAR_NAVIGATION_CABINET_BUTTONS.crown_molding:
            //crown molding displayed as edges and backsplashes
            //shape.addCrownMolding();
            break
          case SIDEBAR_NAVIGATION_CABINET_BUTTONS.end_panel:
          case SIDEBAR_NAVIGATION_BUTTONS.end_cap:
            //crown molding displayed as edges and backsplashes
            //shape.addCrownMolding();
            break;
          case SIDEBAR_NAVIGATION_CABINET_BUTTONS.spacer:
            //line = shape.getHoverSegment(true);
            line = workspace.getHoveredLine();
            if (line) {
              workspaceControllers.spacer.createSpacer(line.from, line.to, shape.getPosition());
              line.resetState();
              shape.resetState();
              tookAction = false // see QCDES-4731 we need to call mouseUp on each shape
            }
            //store.dispatch(setSQFTActiveButton(SIDEBAR_NAVIGATION_CABINET_BUTTONS.spacer));
            //store.dispatch(setSQFTMenuOpened(false));

            break;
          default:
            break;
        }
      } else if (bumpoutLine) {
        switch(activeButton) {
          case "delete":
            //workspace.removeShape(bumpoutLine.getAttachedShape());
            bumpoutLine.deleteAttachedItem();
            tookAction = false;
            break;
          default:
            break;
        }
      } else {
        if (activeButton === "rotate-left") {
          //EventManager.stealCursor(true);
          //EventManager.setCursor("rotate-left", self, true);
        } else if (activeButton === "delete") {
          EventManager.stealCursor(true);
          EventManager.setCursor("delete", self, true);
        } else if (activeButton === SIDEBAR_NAVIGATION_BUTTONS.text) {
          if (!workspace.textBoxManager.isBoxActive()
            && !isITextEditing
          ) {
            let pos = getMousePositionOnField(mousePos.x, mousePos.y);
            let textBox = new TextBox(pos);
            textBox.init();

            console.log(config.workspace.menuItemActive);

            //this.navButtonClick(nodes.sidebar.navButtons[0]); // change icon
            config.workspace.menuItemActive = null; // reset action
          }
        }
        tookAction = false;
        resetCursor = false;
        //$('#design-default').click();
      }
      const state = store.getState();
      const updateCalculations = state.sqftState.updateCalculations;
      store.dispatch(updateSQFTCalculations(updateCalculations + 1));
      if (resetCursor) {
        EventManager.resetCursor(self);
        config.workspace.menuItemActive = null;
      }
    }

    return tookAction;
  };

  this.init = () => {
    EventManager.addEvent(
      EventManager.events.MOUSE_UP,
      self.workspace_onClick,
      self,
      EventManager.priorities.OVERALL
    );
  };

  this.hideAngleTooltip = () => {
    // const input = document.getElementById("angle_input");
    const angleTooltip = document.getElementById("angle-tooltip");
    const inputArrows = [].slice.call(document.querySelectorAll("#angle-tooltip [data-action]"));
    const inputSubmit = [].slice.call(document.querySelectorAll('[data-action="angle-input-submit"]'));

    if (angleTooltip) {
      angleTooltip.style.display = "none";
      inputArrows.forEach(function (elem) {
        elem.parentNode.replaceChild(elem.cloneNode(true), elem);
      });
      inputSubmit[0]?.removeEventListener('click', self.deActivateRotateAngle);
    }
  }
};

//todo
const resetEvents = function () {
  EventManager.stealCursor(true);
  EventManager.resetCursor(self);
  workspace.setAllowEdges(false);
  workspace.setAllowBumpoutEdges(false);
  config.workspace.menuItemActive = null
};

export const clearAllMenusEvents = () => {
  sqftEventManager.stealCursor(true); //  making cursor default
  sqftEventManager.resetCursor(sqftEventManager.currentCursorOwner); // ??
  sqftConfig.workspace.menuItemActive = null; // out of resize, rotate, delete
  // let zz= sqftEventManager;
  // console.log(zz)
  // debugger // eslint-disable-line no-debugger

  workspace.setAllowEdges(false); //  removing sizing lines
  workspace.setAllowBumpoutEdges(false); //  removing sizing lines
  workspace.setAllowMiteredEdges(false); //  removing mitered lines

  if (workspace.miteredController instanceof MiteredController) {
    workspace.miteredController.deregisterEvents();
  }
  clearRotateAngles();	// remove rotateAngle
  sqftConfig.highlight.points = false;	// remove radiuses
  sqftConfig.highlight.lines = false;  // disable lines highlighting
  sqftConfig.highlight.type = '';  // disable lines highlighting
  sqftConfig.highlight.id = null;  // disable lines highlighting
  sqftEventManager.removeStuckCursorEvents();

  store.dispatch(setSQFTContextMenu({isOpened: false}));
  store.dispatch(setSQFTActiveButton(""));
  store.dispatch(setSQFTActiveSubMenuButton(""));
  store.dispatch(setSQFTActiveLevel3Button(null));
  store.dispatch(setGroheFiltersSearchText(""));
  store.dispatch(showFilters(false));
  FreeDraw.drawFinish();
  FreeDraw.destroy();
  toolsControllers.shapeFreeForm.drawFinish();
  toolsControllers.shapeFreeForm.closeThicknessPopup();
  sqftShapeManager.disableRotatableStateForAllShapes();
  store.dispatch(deleteChangeValuePopup(FREE_FORM_THICKNESS_POPUP_ID));
  store.dispatch(setSQFTActiveShapeId(null));
  store.dispatch(setFeaturePicker({ isOpen: false, partIds: [], shapeId: '', type: '' }));
  closeSQFTPopup();
};



export default new WorkspaceEvents();
